// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LabelledInput_wrapper__j1HxE","variant-owner-tools":"LabelledInput_variant-owner-tools__2-nEU"};